import {createColumn, defaultColumns, inputTextField, relationField, booleanComponent, editorComponent, fileField} from '../_defaults/columns'
import {normalizeDate} from '../../utils/dateHelpers'

export const columns = [
  createColumn({
    label: 'Event Name',
    isTitle: true,
    field: 'name',
    section: 'Basics',
    component: inputTextField({req: true, max: 255})
  }),
  createColumn({
    label: 'Event Registration URL',
    field: 'eventRegistrationUrl',
    section: 'Basics',
    description: 'Use this to link off to another website where the registration will be handled',
    component: inputTextField({req: false, max: 255, type: 'url'})
  }),
  fileField({
    label: 'Event Image (396 x 230 pixels)',
    req: false,
    visible: false,
    field: 'imageUrl',
    section: 'Basics',
    mediaCollection: 'event'
  }),
  createColumn({
    label: 'Short Description',
    field: 'shortDescription',
    visible: false,
    section: 'Basics',
    defaultValue: '',
    description: '1023 character limit.  If this is not filled, the Description field will be used for the short description.  This is only used on the event list page.',
    // component: inputTextField({ req: false, max: 255, type: 'url' })
    component: editorComponent
  }),
  createColumn({
    label: 'Description',
    field: 'description',
    visible: false,
    section: 'Basics',
    defaultValue: '',
    // component: inputTextField({ req: false, max: 255, type: 'url' })
    component: editorComponent
  }),
  createColumn({
    label: 'Thank You Message',
    field: 'thankYouMessage',
    visible: false,
    section: 'Basics',
    defaultValue: '',
    description: 'If you leave this blank, the standard thank you message will display.',
    // component: inputTextField({ req: false, max: 255, type: 'url' })
    component: editorComponent
  }),
  createColumn({
    label: 'Event Dates',
    field: 'eventDate',
    section: 'Scheduling',
    // displayValue: row => {
    //   let returnVal = ''
    //   if (row.eventDate) {
    //     for (let event of row.eventDate) {
    //       returnVal += `(${normalizeDate(event.startDate, 'MMM DD YYYY - h:mm a')} - ${normalizeDate(event.endDate, 'MMM DD YYYY - h:mm a')}) `
    //     }
    //     return returnVal
    //   }
    // },
    ...relationField({
      type: 'many',
      fk: 'eventId',
      localKey: 'id',
      namespace: 'eventDate',
      filterIs: 'text-filter',
      parentRestraint: true,
      validation: {required: true},
      props: {showBrowse: false, showSearch: false}
      // subtitle: 'shortDescription'
      // label: context => {
      //   if (context.isAllDay) {
      //     return ['All Day Event', normalizeDate(context.startDate, 'MMM DD YYYY')].join(' - ')
      //   }
      //   return [normalizeDate(context.startDate, 'MMM DD YYYY'), normalizeDate(context.endDate, 'MMM DD YYYY')].join(' - ')
      // }
    })
  }),
  createColumn({
    label: 'Event is Active',
    field: 'active',
    type: 'boolean',
    section: 'Availability',
    description: 'Event is listed and available to be seen',
    defaultValue: true,
    component: booleanComponent
  }),
  createColumn({
    label: 'Enable Registration',
    field: 'enableRegistration',
    type: 'boolean',
    section: 'Availability',
    description: 'Toggle if the Event is open for registrations or not',
    defaultValue: true,
    component: booleanComponent
  }),
  createColumn({
    label: 'Must Register By',
    field: 'registerBy',
    section: 'Availability',
    type: 'date',
    description: 'Stop registrations by a date',
    // displayValue: context => normalizeDate(context, 'MMM DD YYYY'),
    displayValue: row => {
      return row.registrationDate ? normalizeDate(row.registerBy, 'MMM DD YYYY') : 'N/A'
    },
    component: {
      is: 'q-datetime',
      props: {
        type: 'datetime',
        format24h: false,
        format: 'MMM DD YYYY h:mm a',
        okLabel: 'Set Date / Time',
        modal: true
        // dark: true
      },
      validation: {
        required: false
      }
    }
  }),
  createColumn({
    label: 'Address',
    field: 'address',
    section: 'Location',
    ...relationField({
      type: 'one',
      label: 'line1',
      namespace: 'address',
      filterIs: 'text-filter'
    })
  }),
  createColumn({
    label: 'Contact Name',
    field: 'contactName',
    section: 'Contact',
    component: inputTextField({req: false, max: 255})
  }),
  createColumn({
    label: 'Contact Email',
    field: 'contactEmail',
    section: 'Contact',
    // icon: 'email',
    // type: 'email',
    component: inputTextField({req: false, type: 'email', max: 255})
  }),
  createColumn({
    label: 'Contact Phone Number',
    field: 'contactPhone',
    section: 'Contact',
    component: inputTextField({req: false, max: 255, type: 'tel'})
  }),
  createColumn({
    label: 'Non-Member Price',
    field: 'nonMemberPrice',
    section: 'Pricing',
    type: 'number',
    component: inputTextField({req: false, type: 'number', money: true}),
    description: 'Fill in Non-Member price only if you wish everyone to have the same price.'
  }),
  createColumn({
    label: 'Member Price',
    field: 'memberPrice',
    section: 'Pricing',
    type: 'number',
    component: inputTextField({req: false, type: 'number', money: true}),
    description: 'Fill in Member price to define a special price for members.'
  }),
  createColumn({
    label: 'Allow Credit Card',
    field: 'paymentAllowCc',
    type: 'boolean',
    section: 'Pricing',
    description: 'Enables credit card payment option for this event',
    defaultValue: true,
    component: booleanComponent
  }),
  createColumn({
    label: 'Allow Bank Transfer',
    field: 'paymentAllowBank',
    type: 'boolean',
    section: 'Pricing',
    description: 'Enables bank transfer payment option for this event',
    defaultValue: true,
    component: booleanComponent
  }),
  createColumn({
    label: 'Allow Invoice',
    field: 'paymentAllowInvoice',
    type: 'boolean',
    section: 'Pricing',
    description: 'Enables Invoice Me as a payment option for this event',
    defaultValue: true,
    component: booleanComponent
  }),
  createColumn({
    label: 'Event Discounts',
    field: 'eventDiscount',
    section: 'Pricing',
    ...relationField({
      type: 'many',
      fk: 'id',
      localKey: 'eventId',
      parentRestraint: true,
      namespace: 'eventDiscount',
      filterIs: 'text-filter',
      props: {showBrowse: false, showSearch: false}
    })
  }),
  createColumn({
    label: 'Type',
    field: 'eventType',
    section: 'Options',
    // defaultValue: { id: 1, name: 'Normal', removalDate: null },
    ...relationField({
      type: 'one',
      namespace: 'eventType',
      filterIs: 'text-filter',
      // fk: 'eventTypeId',
      // localKey: 'id',
      localKey: 'eventTypeId',
      validation: {
        required: true
      },
      props: {addButton: false, allowEdit: false}
    })
  }),
  createColumn({
    label: 'Group/Team Limit',
    field: 'teamLimit',
    type: 'number',
    section: 'Options',
    description: 'Place a number in to declare this a team event, and how many people can be in a team.',
    defaultValue: '0',
    //   label: 'ID',
    //   field: 'id',
    //   visible: false,
    //   searchable: true,
    //   type: 'number',
    //   sortable: true,
    //   filterable: false,
    //   component: null
    component: inputTextField({req: false, type: 'number', props: {value: 0}})
  }),
  createColumn({
    label: 'Members Only',
    field: 'isMemberOnly',
    type: 'boolean',
    section: 'Options',
    description: 'Limit this event to active members only',
    defaultValue: false,
    component: booleanComponent
  }),
  createColumn({
    label: 'Max People',
    field: 'maxNumPersons',
    type: 'number',
    section: 'Options',
    description: 'Limit how many people may attend. Leave 0 for unlimited.',
    defaultValue: '0',
    component: inputTextField({req: false, type: 'number', props: {value: 0}})
  }),
  createColumn({
    label: 'QuickBooks Product/Service Label',
    field: 'qbProdservName',
    section: 'Accounting / QuickBooks',
    description: 'Select the Product/Service that QB line items will be marked as.',
    visible: false,
    validation: {required: true},
    component: {
      is: 'quickbooks-product-service',
      validation: {required: true},
    }
    // component: inputTextField({ req: false, max: 255 })
  }),
  createColumn({
    label: 'QuickBooks Product/Service ID',
    field: 'qbProdservId',
    type: 'number',
    section: 'Accounting / QuickBooks',
    description: 'Select the Product/Service that QB line items will be marked as.',
    visible: false,
    // holdFromEdit: true,
    component: null
    // component: inputTextField({req: true, type: 'number'})
  }),
  createColumn({
    label: 'Sponsorships',
    field: 'sponsorship',
    section: 'Sponsorships',
    visible: false,
    display: 'sponsorship.name',
    ...relationField({
      type: 'many',
      fk: 'eventId',
      localKey: 'id',
      namespace: 'sponsorship',
      parentRestraint: true,
      filterIs: 'text-filter',
      label: 'name',
      subtitle: '',
      props: {showBrowse: false, showSearch: false}
    })
  }),
  createColumn({
    label: 'Sponsorship Display Titles & Media',
    field: 'sponsorshipTitle',
    section: 'Sponsorship Recognition',
    visible: false,
    // display: 'sponsorship.name',
    ...relationField({
      type: 'many',
      fk: 'eventId',
      localKey: 'id',
      namespace: 'sponsorshipTitle',
      parentRestraint: false,
      filterIs: 'text-filter',
      label: 'title',
      subtitle: '',
      requiresParentSave: true,
      props: {showBrowse: false, showSearch: false}
    })
  }),
  createColumn({
    label: 'Custom Questions',
    field: 'question',
    section: 'Custom Questions',
    visible: false,
    filterable: false,
    searchable: false,
    sortable: false,
    defaultValue: [],
    // component: {
    //   is: 'custom-questions'
    // }
    ...relationField({
      type: 'many',
      fk: 'id',
      localKey: 'eventId',
      parentRestraint: true,
      linkTable: false,
      namespace: 'question',
      filterIs: 'text-filter',
      componentIs: 'custom-questions',
      orderBy: 'sort',
      filterable: false,
      searchable: false,
      sortable: false
    })
  })
  //   createColumn({
  //     // LETS REMOVE THIS?
  //     label: 'Flat Rate',
  //     field: 'isFlatRate',
  //     section: 'Pricing',
  //     type: 'boolean',
  //     description: 'Make the cost the same for members and non members',
  //     component: booleanComponent
  //   }),
  //   createColumn({
  //     label: 'Teams',
  //     field: 'eventTeams',
  //     section: 'Data Relations',
  //     ...relationField({
  //       type: 'many',
  //       fk: 'eventId',
  //       localKey: 'eventId',
  //       namespace: 'eventTeam',
  //       filterIs: 'text-filter',
  //       label: 'teamName',
  //       subtitle: ''
  //     })
  //   }),
  //   createColumn({
  //     label: 'Discounts',
  //     field: 'eventDiscounts',
  //     section: 'Data Relations',
  //     display: 'discount.code',
  //     ...relationField({
  //       type: 'many',
  //       fk: 'event',
  //       localKey: 'id',
  //       namespace: 'eventDiscount',
  //       filterIs: 'text-filter',
  //       label: 'discount.code',
  //       subtitle: ''
  //     })
  //   })
].concat(defaultColumns)
